var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-list"},[_c('Header'),_c('HeaderTitle'),_c('div',{staticClass:"main-page-content contain-left-right"},[_c('LeftContent',{attrs:{"type":"student"}}),_c('RightContent')],1),_c('div',{staticClass:"blank20"}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }